// Stock History screen — feed of recent stock movements.
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { DateRange } from "react-day-picker"
import ApparelMenu from "./SubComponents/apparelMenu"
import { getStockHistoryAction } from "../Store/actions/apparelAction"
import StockHistoryTable from "./inventory/StockHistoryTable"
import { DateRangePicker } from "./Reports/DateRangePicker"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "ui/select"

const PAGE_SIZE = 20;

const TRANSACTION_TYPES = [
    { value: "PURCHASE", label: "Purchase" },
    // Sales data is excluded from the ledger for now — re-enable once sale-consumption logging is ready to be shown here.
    // { value: "SALE_CONSUMPTION", label: "Sale Consumption" },
    { value: "STOCK_ADJUSTMENT", label: "Stock Adjustment" },
    { value: "SALES_RETURN", label: "Sales Return" },
];

const StockHistory = () => {
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [operationType, setOperationType] = useState("");
    const [dateRange, setDateRange] = useState<DateRange | undefined>(undefined);
    const dispatch = useDispatch();
    const apparelReducerState: any = useSelector((state: any) => state.ApparelReducerState);
    const {
        getStockHistoryData,
        getStockHistoryLoad,
    } = apparelReducerState;

    const stockHistoryResult = getStockHistoryData?.getStockHistory;
    const stockHistoryList = stockHistoryResult?.rows || [];
    const stockHistoryPage = stockHistoryResult?.page;

    useEffect(() => {
        dispatch(getStockHistoryAction({
            limit: PAGE_SIZE,
            offset: (page - 1) * PAGE_SIZE,
            searchText: searchText || undefined,
            operationType: operationType || undefined,
            fromDate: dateRange?.from ? moment(dateRange.from).format("YYYY-MM-DD") : undefined,
            toDate: dateRange?.to ? moment(dateRange.to).format("YYYY-MM-DD") + " 23:59:59" : undefined,
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searchText, operationType, dateRange])

    const onSearch = (query: string) => {
        setSearchText(query);
        setPage(1);
    }

    const onOperationTypeChange = (value: string) => {
        setOperationType(value === "ALL" ? "" : value);
        setPage(1);
    }

    const onDateRangeChange = (range: DateRange | undefined) => {
        setDateRange(range);
        setPage(1);
    }

    return (
        <div className="mz h-full overflow-y-auto px-6 py-4">
            <ApparelMenu selectedKey="stockHistory" />
            <StockHistoryTable
                data={stockHistoryList}
                loading={getStockHistoryLoad}
                title="Stock Ledger"
                searchValue={searchText}
                onSearch={onSearch}
                searchPlaceholder="Search by Product ID or ID..."
                pagination={{
                    page: stockHistoryPage?.currentPage || page,
                    total: stockHistoryPage?.totalCount || 0,
                    pageSize: PAGE_SIZE,
                    onChange: setPage,
                }}
                toolbar={
                    <>
                        <DateRangePicker value={dateRange} onChange={onDateRangeChange} disableFuture />
                        <Select value={operationType || "ALL"} onValueChange={onOperationTypeChange}>
                            <SelectTrigger className="w-[200px]"><SelectValue placeholder="All transaction types" /></SelectTrigger>
                            <SelectContent>
                                <SelectItem value="ALL">All transaction types</SelectItem>
                                {TRANSACTION_TYPES.map((t) => (
                                    <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </>
                }
            />
        </div>
    )
}

export default StockHistory
